/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CalculDetail {
  labelDetail: string
  valuedDetail: string
  unit: CalculDetailUnitEnum
  link: CalculDetailLinkEnum
}

export const CalculDetailUnitEnum = {
  EUROS: "EUROS",
  K_EUROS: "K_EUROS",
  JOURS: "JOURS",
  MONTH: "MONTH",
  NONE: "NONE"
} as const

export type CalculDetailUnitEnum = (typeof CalculDetailUnitEnum)[keyof typeof CalculDetailUnitEnum]
export const CalculDetailLinkEnum = {
  CR: "CR",
  BFR: "BFR",
  CAF: "CAF",
  PF: "PF",
  TVA: "TVA",
  PRETS: "PRETS",
  PRETS_PASSES: "PRETS_PASSES",
  NONE: "NONE",
  BILANCEDANT: "BILANCEDANT"
} as const

export type CalculDetailLinkEnum = (typeof CalculDetailLinkEnum)[keyof typeof CalculDetailLinkEnum]
